const faqItems = [
  {
    q: '51爆料网的内容来源可靠吗？',
    a: '我们的所有内容均来自公开渠道整理与用户投稿，编辑团队会对每条信息进行多方交叉验证。虽然我们追求信息的真实性和时效性，但仍建议读者以理性态度看待爆料内容，多方核实后再形成判断。',
  },
  {
    q: '如何在51爆料网上投稿爆料？',
    a: '你可以通过页面上的"线索投稿"入口提交爆料内容。我们承诺严格保护投稿人的隐私信息，所有投稿均经过匿名化处理后再发布。提交时请尽量提供详细的证据材料，以便编辑团队快速核实。',
  },
  {
    q: '51爆料网有手机APP吗？',
    a: '是的，我们提供iOS和Android双平台APP。APP端支持推送通知功能，让你第一时间收到最新爆料提醒。你可以在本页面的下载区域找到对应平台的下载入口。',
  },
  {
    q: '网站上爆料的内容会不会有法律风险？',
    a: '51爆料网严格遵守国家法律法规，所有发布内容均经过合规审核。我们坚持基于事实的报道原则，对于无法核实的信息会明确标注"待核实"。如发现内容存在不实之处，欢迎通过投稿渠道反馈，我们会及时处理。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="relative py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row gap-12 md:gap-16">
          <div className="md:w-[38%]">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
              <i className="ri-question-line text-[10px]"></i>
              常见问题
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight mb-4">
              有疑问？
              <br />
              <span className="font-heading italic text-accent-400">看这里</span>
            </h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6">
              关于51爆料网的常见问题解答。如果这里没有你想了解的内容，欢迎通过投稿渠道联系我们。
            </p>
            <div className="relative">
              <input
                type="email"
                placeholder="输入邮箱，订阅每日爆料"
                className="w-full bg-transparent border-b border-background-300 pb-2.5 text-sm text-foreground-200 placeholder:text-foreground-600 focus:outline-none focus:border-accent-500 transition-colors"
              />
              <button className="mt-3 px-5 py-2 bg-transparent border border-accent-500/40 text-accent-400 text-xs font-semibold rounded-full hover:bg-accent-500/10 transition-all cursor-pointer whitespace-nowrap">
                订阅更新
              </button>
            </div>
          </div>

          <div className="md:w-[62%] space-y-6">
            {faqItems.map((item, i) => (
              <div key={i} className="pb-6 border-b border-background-200/30 last:border-0">
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-400 text-xs font-bold">
                    {i + 1}
                  </span>
                  <div>
                    <h3 className="text-sm md:text-base font-bold text-foreground-100 mb-2">
                      {item.q}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}